import React, { useEffect } from "react";
import { CloseButtonProps } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";

import { Notificator } from "../store";
import { useIntlTranslate } from "../../../hooks";
import { Icon } from "../../icon/Icon";
import { SessionStorageKeys, sessionStorageProxy } from "../../../services";
import { getRoamingDevicesCount } from "../../../store/devices/logicalDevices";
import { isSPSONAvailable } from "../../../store/account";
import { getRemoteReminderDialogVisibilityStatus } from "../../../store/reminder/reminder.selectors";
import { areAllHomePageDevicesLoaded } from "../../../store/devices/devices.selectors";

export const useRemoteReminderBanner = () => {
  const dispatch = useDispatch();
  const isDialogVisible = useSelector(getRemoteReminderDialogVisibilityStatus);
  const isToastVisible = !sessionStorageProxy.getItem(
    SessionStorageKeys.IsPromoDismissed
  );
  const isRemoteEnabled = useSelector(isSPSONAvailable);
  const remoteDevicesCount = useSelector(getRoamingDevicesCount);
  const isLoadingFinished = useSelector(areAllHomePageDevicesLoaded);

  useEffect(() => {
    if (
      isRemoteEnabled &&
      isLoadingFinished &&
      remoteDevicesCount === 0 &&
      isToastVisible &&
      !isDialogVisible
    ) {
      setTimeout(() => {
        dispatch(Notificator.remoteInfo());
      }, 1000);
    }
  }, [
    dispatch,
    isRemoteEnabled,
    isLoadingFinished,
    remoteDevicesCount,
    isToastVisible,
    isDialogVisible,
  ]);
};

export const CloseButton = ({ closeToast }: CloseButtonProps) => {
  const translate = useIntlTranslate();

  const close = (e) => {
    sessionStorageProxy.setItem(SessionStorageKeys.IsPromoDismissed, "true");
    closeToast(e);
  };

  return (
    <UnstyledButton
      className="notification__close-icon notification__icon--button"
      onClick={close}
      aria-label={translate("aria_close")}
    >
      <Icon icon="fa-regular fa-times" />
    </UnstyledButton>
  );
};
